export const sprite = () => ({
    position: 'absolute',
    top: '-1%',
    left: '40%',
});

export const spriteElement = () => ({
    opacity: 0.8,
    width: '60vw',
    maxWidth: 1248,
    height: '60vw',
    maxHeight: 1248,
});
